import React from 'react';
import { NavLink } from 'react-router-dom';
import Collapsible from 'react-collapsible';

const Dropdown = props => (
    <Collapsible handleTriggerClick={ props.onTriggerClick }
                 open={ props.open }
                 trigger={ props.trigger }
                 transitionTime={200}
                 triggerClassName="toggle"
                 triggerOpenedClassName="toggle open">

        <ul className="dropdown-inner">
            {
                props.content.map(item => (
                    <li key={ item.label }>
                        <NavLink to={ item.to }>{ item.label }</NavLink>
                    </li>
                ))
            }
        </ul>

    </Collapsible>
);

export default Dropdown;



// WEBPACK FOOTER //
// ./src/components/UI/Collapsible.js